module.exports = __webpack_public_path__ + "static/media/allergen_eggs.665b8d7b.png";